// extracted by mini-css-extract-plugin
export var centerText = "_cs-8";
export var container = "_cs-0";
export var doughnutContainer = "_cs-7";
export var legend = "_cs-a";
export var legendItemColorDisplay = "_cs-b";
export var legendItemLabel = "_cs-d";
export var legendItemValue = "_cs-c";
export var lg = "_cs-5";
export var maxWidth = "_cs-9";
export var md = "_cs-4";
export var responsive = "_cs-6";
export var sm = "_cs-3";
export var xs = "_cs-2";
export var xxs = "_cs-1";